var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('ejs-chiplist',{attrs:{"text":_vm.text,"cssClass":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }